export default "__VITE_ASSET__CfJHnBXB__"